import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasBathhouse = createSelector(selectJsonQuery, jsonQuery => getTermValue('bathhouse')(jsonQuery));
